module.exports = __webpack_public_path__ + "img/blue-arrow-left.20826665.svg";